import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { CenterFlex } from '@/components/base';
import Spinner from '@/components/Common/Spinner';
import zIndex from '@/styles/zIndex';

const PageLoading = (props: {
  children?: ReactNode;
  style?: CSSProperties;
  wrapperStyle?: CSSProperties;
}) => {
  return (
    <Style style={props.style}>
      <Wrapper d="column" g="16px" style={props.wrapperStyle}>
        {props.children || <Spinner size={32} />}
      </Wrapper>
    </Style>
  );
};

const Style = styled.div`
  position: fixed;
  z-index: ${zIndex.pageLoading};
  top: 0;
  left: 0;
  width: 100%;
`;

const Wrapper = styled(CenterFlex)`
  width: 100%;
  height: 100vh;
  background-color: ${(props) => props.theme.colors.FD40};
`;

export default PageLoading;
